import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ProfileService } from '../../../services/profile.service';
import { Module, AllCommunityModules } from '@ag-grid-community/all-modules';
import { EditButtonRendererComponent } from '../../../renderer/edit-button-renderer.component';
import { DeleteButtonRendererComponent } from '../../../renderer/delete-button-renderer.component';
import * as _ from 'lodash';
import { ModalDirective } from 'ngx-bootstrap/modal';
import * as moment from 'moment';
import { ConstantService } from '../../../services/constant.service';
import { ApiService } from '../../../services/api.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

import * as data from '../../../../assets/data/data.json';
import { Papa } from 'ngx-papaparse';
import { ValidateCsvService } from '../../../services/validateCsv.service';
import { Md5 } from 'ts-md5/dist/md5';
import { Router } from '@angular/router';

@Component({
  selector: 'app-experience-letter-upload',
  templateUrl: './experience-letter-upload.component.html',
})
export class ExperienceLetterUploadUploadComponent implements OnInit {
  months = this.constantService.MONTHS;
  filterParams = {
    issue_date: '',
    org_id: ''
  };
  years = [
    moment().format("YYYY"),
    moment().subtract(1, "years").format("YYYY"),
  ];
  selectedOrg: any = {};
  orgObj: any = {};
  constructor(private profileService: ProfileService,
    private constantService: ConstantService,
    private apiService: ApiService,
    private papa: Papa,
    private validateCsvService: ValidateCsvService,
    private router: Router) {

  }

  ngOnInit(): void {
    this.fetchOrg();
  }


  organizationList: any = [];
  fetchOrg() {
    this.apiService.getData('organization').then((resp) => {
      this.organizationList = resp;
      _.each(this.organizationList, (org) => {
        this.orgObj[org.srl_no] = org;
      }
      )
    })
  }
  loader: boolean = false;
  lastExpLetterId: any;
  fetchLastIdOfExpletterByOrg() {
    console.log(this.orgObj[this.filterParams.org_id], 'org');
    this.loader = true;
    let queryString = `MAX(letter_no) as last_letter_no FROM experience_letter WHERE experience_letter.org_id = ${this.filterParams.org_id}`;
    this.apiService.getCustomData(btoa(queryString)).subscribe((resp: any) => {
      console.log(resp[0].last_letter_no);
      this.lastExpLetterId = resp[0].last_letter_no;

    })
  }



  @ViewChild('fileImportInput') fileImportInput: ElementRef;
  private entry_operator_id = "";


  csvHeaderFields = ['reference_no', 'client_name', 'client_address', 'employee_name', 'mobile_number', 'designation', 'date_of_birth', 'father_husband_name', 'joining_date', 'job_last_date'];
  // csvHeaderFields = ["userType","username","password","fullName","contactNo","permission"];
  isHeader: any = false;
  csvErrorMsg: any = null;
  isCsvBlank: any = false;
  records = {
    recordsUploaded: 0,
    totalRecords: 0,
    progress: 0
  };
  patientDetailClone: any = {};
  flag = {
    enableSave: false
  }


  csvRecords: any[] = [];
  rawCsv = null;
  header = true;
  csvContent: string;
  formattedData = [];
  loadCsvFile($event: any) {
    // Select the files from the event
    const files = $event.srcElement.files;
    let that = this;
    if (files && files.length > 0) {
      let file: File = files.item(0);
      let reader: FileReader = new FileReader();
      reader.readAsText(file);
      reader.onload = (e) => {
        that.rawCsv = reader.result as string;
        //  console.log(that.rawCsv);
        that.parseCSV();
      }
    }

  }

  parseCSV() {
    let that = this;
    let options = {
      header: true,
      complete: (results, file) => {
        console.log('Parsed: ', results);
        that.csvRecords = results.data;
        that.validateCSV(that.csvRecords, results.meta.fields);
      }
    }
    this.papa.parse(this.rawCsv, options);
  }




  table_header = "(`org_id`, `reference_no`, `letter_no`,`client_name`,`client_address`,`employee_name`,`mobile_number`,`designation`,`date_of_birth`,`father_husband_name`,`joining_date`,`job_last_date`,`issue_date`,`secret_key`)";

  secretKey() {
    let sec_key = this.makeid(5);
    return Md5.hashStr(sec_key);
  }

  convertBigInt(number) {
    console.log(number, +number);
    return +number;
  }

  validateCSV(csv, csvFields) {
    // console.log(csv)
    if (csv.length === 0) {
      this.isHeader = false;
      this.isCsvBlank = true;
      this.csvErrorMsg = {
        blank_error: 'CSV file must contain atleast 1 record'
      }
    } else {
      console.log(_.sortBy(this.csvHeaderFields), _.sortBy(csvFields))
      if (!_.isEqual(_.sortBy(this.csvHeaderFields), _.sortBy(csvFields))) {
        this.isHeader = false;
        this.isCsvBlank = false;
        let diff: string[] = _.difference(_.sortBy(this.csvHeaderFields), _.sortBy(csvFields));
        console.log(diff)
        this.csvErrorMsg = {
          header_required: 'CSV file must contain these header ' + diff.join(", ") + " or check spellings",
          // header_available: 'Existing CSV file contains header in format [' + csv[0] + ' ] ',
        };
      } else {
        this.isHeader = true;
        this.isCsvBlank = false;
        this.csvErrorMsg = {};
        let letterNo = (this.lastExpLetterId || this.lastExpLetterId > 0) ? parseInt(this.lastExpLetterId) : 1;
        _.each(this.csvRecords, (record) => {
          console.log(record);
          if (record['employee_name'] !== undefined && record['mobile_number'] !== '') {
            this.formattedData.push("( '" + this.clean(this.filterParams.org_id) + "', '" + this.genereateReferenceNo(letterNo++) + "', '" + letterNo++ + "', '" + this.clean(record['client_name']) + "', '" + this.clean(record['client_address']) + "', '" + this.clean(record['employee_name']) + "', '" + this.clean(record['mobile_number']) + "', '" +
              this.clean(record['designation']) + "', '" + this.clean(record['date_of_birth']) + "', '" + record['father_husband_name'] + "', '" + record['joining_date'] + "', '" + record['job_last_date'] + "', '" + this.filterParams.issue_date + "', '" + this.secretKey() + "')");
          }
        })
        console.log(this.formattedData);
        this.flag.enableSave = true;
      }
    }
  };

  clean(str) {
    // if (str) {
    //   return (_.trim(str.replace(/[^\w\s]/g, '')));
    // } else {
    //   return str;
    // }
    return str;
  }

  parseNumer(i) {
    if (i) {
      return (parseInt(i)).toFixed();
    } else {
      return '';
    }
  }

  successMsg: string = "";
  csvUpload() {
    let that = this;
    this.records.totalRecords = this.formattedData.length;
    let chunkSize = 200;
    console.log("helo");
    let chunkData = _.chunk(_.slice(this.formattedData, 0), chunkSize);
    this.records.recordsUploaded = 0;
    let i = 0;
    _.each(chunkData, (data) => {
      setTimeout((val) => {
        let payload = {
          header: btoa(unescape(encodeURIComponent(this.table_header))),
          data: btoa(unescape(encodeURIComponent(data)))
        }
        console.log(this.table_header, data);
        this.apiService.addBulkData('experience_letter', payload).subscribe((response) => {
          that.records.recordsUploaded = that.records.recordsUploaded + data.length;
          console.log(that.records.recordsUploaded + " - " + that.records.totalRecords);
          console.log((that.records.recordsUploaded * 100) / that.records.totalRecords);
          that.records.progress = (that.records.recordsUploaded * 100) / that.records.totalRecords;

          if (that.records.progress === 100) {
            this.successMsg = "Records successfully uploaded.";
            setTimeout(() => {
              that.records.recordsUploaded = 0;
              this.router.navigate(['/experience_letter'])
            }, 2000)
          }
        })
      }, i * 3000);
      i++;

    })
  }

  resetUpload() {
    this.fileImportInput.nativeElement.value = '';
    this.records = {
      recordsUploaded: 0,
      totalRecords: 0,
      progress: 0
    };
    this.csvRecords = [];
    this.csvContent = '';
    this.formattedData = [];
    this.csvErrorMsg = {};
    // this.selectedVehicleId = '';
    // this.selectList.nativeElement.value = 'Select Vehicle';
  }


  makeid(length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  genereateReferenceNo(letterNo: number) {
    let refNo = this.orgObj[this.filterParams.org_id].org_code + '/A-' + letterNo + '/PAT/' + moment().format('YY');
    return refNo;
  }

}
